export const ASSISTANT_ROLE = "Assistant";

export const ASSISTANT_PATHS = {
  students: "/dashboard/students",
  topStudents: "/dashboard/top-students",
  questionBank: "/dashboard/questions-bank",
  exams: "/dashboard/exams",
  homeworkAbsent: "/dashboard/homework-absent-report",
  homeworkAttendance: "/dashboard/homework-attendence-report",
  homeworkReview: "/dashboard/uncomment-homework-report",
  homeworkByChapter: "/dashboard/homework-report-by-chapter",
};

export const ASSISTANT_ALLOWED_PATHS = Object.values(ASSISTANT_PATHS);

export const isAssistantRole = (roleName) => roleName === ASSISTANT_ROLE;

export const isAssistantAllowedPath = (pathname) =>
  ASSISTANT_ALLOWED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
